import React, { useState } from "react";
import "./Contato.css";
import { Mail, Phone, MapPin, Send } from "lucide-react";

const Contato = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    clinic: "",
    specialty: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    const formatPhone = (val) => {
      const cleaned = val.replace(/\D/g, "").slice(0, 11);
      if (cleaned.length <= 2) return `(${cleaned}`;
      if (cleaned.length <= 7)
        return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(
        7
      )}`;
    };

    const newValue = name === "phone" ? formatPhone(value) : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://arcadian-lp.vercel.app/api/sendEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        alert("Mensagem enviada com sucesso!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          clinic: "",
          specialty: "",
          message: "",
        });
      } else {
        alert("Erro ao enviar mensagem. Tente novamente.");
      }
    } catch (err) {
      console.error("Erro no envio:", err);
      alert("Erro ao enviar mensagem. Verifique sua conexão.");
    }
  };

  return (
    <section id="contato" className="contato-section">
      <div className="contato-container" data-aos="fade-in">
        <div className="contato-header">
          <span className="contato-label">Entre em Contato</span>
          <h2 className="contato-title">
            Vamos transformar <span className="highlight">sua clínica?</span>
          </h2>
          <p className="contato-subtitle">
            Converse com nossos especialistas e descubra como podemos elevar sua
            clínica ao próximo nível. Primeira consulta sem compromisso.
          </p>
        </div>

        <div className="contato-grid">
          <div className="contato-info">
            <h3>Fale Conosco</h3>
            <p>
              Nossa equipe está pronta para entender suas necessidades e
              desenvolver uma estratégia personalizada para sua clínica. Entre
              em contato através dos canais abaixo:
            </p>

            <div className="contato-item">
              <div className="icon-wrapper">
                <Phone className="icon" />
              </div>
              <div>
                <h4>Telefone</h4>
                <p>(77) 9 8163-1390</p>
              </div>
            </div>

            <div className="contato-item">
              <div className="icon-wrapper">
                <Mail className="icon" />
              </div>
              <div>
                <h4>E-mail</h4>
                <p>????????</p>
              </div>
            </div>

            <div className="contato-item">
              <div className="icon-wrapper">
                <MapPin className="icon" />
              </div>
              <div>
                <h4>Localização</h4>
                <p>Belo Horizonte, MG - Atendimento Nacional</p>
              </div>
            </div>

            <div className="contato-box">
              <h4>????????</h4>
              <p>
                ????????????????????????????????????????????????
                ???????????????????????????????????????????????? ??????????????
              </p>
            </div>
          </div>

          <div className="contato-form">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Nome Completo *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Seu nome"
                  />
                </div>

                <div className="form-group">
                  <label>E-mail *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>Telefone</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="(11) 9 9999-9999"
                  />
                </div>

                <div className="form-group">
                  <label>Nome da Clínica</label>
                  <input
                    type="text"
                    name="clinic"
                    value={formData.clinic}
                    onChange={handleChange}
                    placeholder="Nome da sua clínica"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Especialidade</label>
                <select
                  name="specialty"
                  value={formData.specialty}
                  onChange={handleChange}
                >
                  <option value="">Selecione a especialidade</option>
                  <option value="dermatologia">Dermatologia</option>
                  <option value="oftalmologia">Oftalmologia</option>
                  <option value="odontologia">Odontologia</option>
                  <option value="cardiologia">Cardiologia</option>
                  <option value="ortopedia">Ortopedia</option>
                  <option value="ginecologia">Ginecologia</option>
                  <option value="psiquiatria">Psiquiatria</option>
                  <option value="outros">Outros</option>
                </select>
              </div>

              <div className="form-group">
                <label>Mensagem</label>
                <textarea
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Conte-nos sobre sua clínica e seus objetivos..."
                />
              </div>

              <button type="submit" className="btn-primary-contact group">
                Enviar Mensagem
                <Send className="send-icon" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contato;
